/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { EmployeeFilteringSettingsV2 } from '../api-models';
// @ts-ignore
import { EmployeeGroupingLaborLevelsRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeGroupingLaborLevelsResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeInfoTextRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeePreferenceResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeTabVisibilityPermissions } from '../api-models';
// @ts-ignore
import { EmployeeTimeCardSettingsRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeTimeCardSettingsV2 } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { RecentlyViewedEmployeeResponseV2 } from '../api-models';
/**
 * UserV2Api - axios parameter creator
 * @export
 */
export const UserV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reads the caller\'s employee-list filter settings (labor-level scope + status type  visibility map). Replaces TaAPI `GET /api/User/EmployeeFilteringSettings`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeFilteringSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-filtering-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Persists the caller\'s employee-list filter settings. Replaces TaAPI  `PUT /api/User/EmployeeFilteringSettings`.
         * @param {EmployeeFilteringSettingsV2} [employeeFilteringSettingsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeFilteringSettingsPut: async (employeeFilteringSettingsV2?: EmployeeFilteringSettingsV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-filtering-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeFilteringSettingsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reads the caller\'s Employee-Center grouping preferences (labor-level depth +  display order per slot). Replaces TaAPI `GET /api/User/EmployeeGroupingLaborLevels`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeGroupingLaborLevelsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-grouping-labor-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Persists the caller\'s Employee-Center grouping preferences. Replaces TaAPI  `PUT /api/User/EmployeeGroupingLaborLevels`.
         * @param {EmployeeGroupingLaborLevelsRequestV2} [employeeGroupingLaborLevelsRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeGroupingLaborLevelsPut: async (employeeGroupingLaborLevelsRequestV2?: EmployeeGroupingLaborLevelsRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-grouping-labor-levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeGroupingLaborLevelsRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reads the caller\'s preferred report ordering (employee id vs full name first).  Replaces TaAPI `GET /api/User/EmployeeIDFullNameDisplayOrder`. Returns the  numeric enum value so the wire shape matches TaAPI exactly (TaAPI emits `0`  while the global `JsonStringEnumConverter` would otherwise emit  `\"FullNameEmployeeID\"`). The PUT accepts both forms for forward compatibility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeIdFullNameDisplayOrderGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-id-full-name-display-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Persists the caller\'s preferred report ordering. Replaces TaAPI  `PUT /api/User/EmployeeIDFullNameDisplayOrder`. TaAPI accepts the body as  EITHER the numeric value (`0`) OR the string name (`\"FullNameEmployeeID\"`);  the FE sends the string form. Accepting both keeps wire parity with TaAPI without  reintroducing the global JsonStringEnumConverter (which would flip every enum-typed  response field to string).
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeIdFullNameDisplayOrderPut: async (body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-id-full-name-display-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the tab-visibility flags evaluated against the target employee\'s role and  the active license. Manager roles may pass any employee id within their facility;  a non-manager caller (e.g. mobile Employee) is constrained by  OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute to their own JWT  `EmployeeInstanceId`. Replaces TaAPI `GET /api/User/{employeeId}/TabsVisibility`.
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeIdTabsVisibilityGet: async (employeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('apiV2UserEmployeeIdTabsVisibilityGet', 'employeeId', employeeId)
            const localVarPath = `/api/v2/user/{employeeId}/tabs-visibility`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reads the caller\'s free-text Employee-Info template. Returns an empty string  when the preference has not been set (LegacyApp fallback default lives in  `FacilityEmployeeServiceV2.GetEmployeeInfoTextAsync`, not here). Replaces  TaAPI `GET /api/User/EmployeeInfoText`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeInfoTextGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-info-text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts the new value via EITHER a query parameter (`?employeeInfoText=...`,  the TaAPI wire shape) OR a JSON body (the more RESTful shape that V2 historically  used). The query parameter takes precedence when both are supplied so existing FE  callers built against TaAPI continue to work unchanged. An empty payload — empty  query value AND empty body — is treated as a \"clear\" operation.
         * @summary Persists the caller\'s free-text Employee-Info template. Replaces TaAPI  `PUT /api/User/EmployeeInfoText`.
         * @param {string} [employeeInfoText] 
         * @param {EmployeeInfoTextRequestV2} [employeeInfoTextRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeInfoTextPut: async (employeeInfoText?: string, employeeInfoTextRequestV2?: EmployeeInfoTextRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-info-text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeInfoText !== undefined) {
                localVarQueryParameter['employeeInfoText'] = employeeInfoText;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeInfoTextRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reads the caller\'s time-card display preferences. Replaces TaAPI  `GET /api/User/EmployeeTimeCardSettings`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeTimeCardSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-time-card-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Persists the caller\'s time-card display preferences. Replaces TaAPI  `PUT /api/User/EmployeeTimeCardSettings`.
         * @param {EmployeeTimeCardSettingsRequestV2} [employeeTimeCardSettingsRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeTimeCardSettingsPut: async (employeeTimeCardSettingsRequestV2?: EmployeeTimeCardSettingsRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/employee-time-card-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeTimeCardSettingsRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns every raw `(PreferenceId, PreferenceValue)` row stored for the caller.  Replaces TaAPI `GET /api/User/Preferences`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserPreferencesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the caller\'s last-viewed employees, most recent first (at most five).  The list is always the JWT caller\'s — there is no way to read another user\'s recents.  Missing, deleted, or no-longer-authorized employees are omitted. An empty list is  `200 []`, not 204,  so the sidebar can bind without a no-content branch. Each row includes  `isActive` and `pictureUrl` with the same semantics as  `POST /api/v2/employees`. After the FE opens an employee  (`GET /employees/{id}/header` records the view), it should call this GET again  so the sidebar reflects server order without duplicating list rules.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserRecentlyViewedEmployeesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/recently-viewed-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserV2Api - functional programming interface
 * @export
 */
export const UserV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Reads the caller\'s employee-list filter settings (labor-level scope + status type  visibility map). Replaces TaAPI `GET /api/User/EmployeeFilteringSettings`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeFilteringSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeFilteringSettingsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeFilteringSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Persists the caller\'s employee-list filter settings. Replaces TaAPI  `PUT /api/User/EmployeeFilteringSettings`.
         * @param {EmployeeFilteringSettingsV2} [employeeFilteringSettingsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeFilteringSettingsPut(employeeFilteringSettingsV2?: EmployeeFilteringSettingsV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeFilteringSettingsPut(employeeFilteringSettingsV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reads the caller\'s Employee-Center grouping preferences (labor-level depth +  display order per slot). Replaces TaAPI `GET /api/User/EmployeeGroupingLaborLevels`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeGroupingLaborLevelsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeGroupingLaborLevelsResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeGroupingLaborLevelsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Persists the caller\'s Employee-Center grouping preferences. Replaces TaAPI  `PUT /api/User/EmployeeGroupingLaborLevels`.
         * @param {EmployeeGroupingLaborLevelsRequestV2} [employeeGroupingLaborLevelsRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeGroupingLaborLevelsPut(employeeGroupingLaborLevelsRequestV2?: EmployeeGroupingLaborLevelsRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeGroupingLaborLevelsPut(employeeGroupingLaborLevelsRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reads the caller\'s preferred report ordering (employee id vs full name first).  Replaces TaAPI `GET /api/User/EmployeeIDFullNameDisplayOrder`. Returns the  numeric enum value so the wire shape matches TaAPI exactly (TaAPI emits `0`  while the global `JsonStringEnumConverter` would otherwise emit  `\"FullNameEmployeeID\"`). The PUT accepts both forms for forward compatibility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeIdFullNameDisplayOrderGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeIdFullNameDisplayOrderGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Persists the caller\'s preferred report ordering. Replaces TaAPI  `PUT /api/User/EmployeeIDFullNameDisplayOrder`. TaAPI accepts the body as  EITHER the numeric value (`0`) OR the string name (`\"FullNameEmployeeID\"`);  the FE sends the string form. Accepting both keeps wire parity with TaAPI without  reintroducing the global JsonStringEnumConverter (which would flip every enum-typed  response field to string).
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeIdFullNameDisplayOrderPut(body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeIdFullNameDisplayOrderPut(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the tab-visibility flags evaluated against the target employee\'s role and  the active license. Manager roles may pass any employee id within their facility;  a non-manager caller (e.g. mobile Employee) is constrained by  OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute to their own JWT  `EmployeeInstanceId`. Replaces TaAPI `GET /api/User/{employeeId}/TabsVisibility`.
         * @param {number} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeIdTabsVisibilityGet(employeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTabVisibilityPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeIdTabsVisibilityGet(employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reads the caller\'s free-text Employee-Info template. Returns an empty string  when the preference has not been set (LegacyApp fallback default lives in  `FacilityEmployeeServiceV2.GetEmployeeInfoTextAsync`, not here). Replaces  TaAPI `GET /api/User/EmployeeInfoText`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeInfoTextGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeInfoTextGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accepts the new value via EITHER a query parameter (`?employeeInfoText=...`,  the TaAPI wire shape) OR a JSON body (the more RESTful shape that V2 historically  used). The query parameter takes precedence when both are supplied so existing FE  callers built against TaAPI continue to work unchanged. An empty payload — empty  query value AND empty body — is treated as a \"clear\" operation.
         * @summary Persists the caller\'s free-text Employee-Info template. Replaces TaAPI  `PUT /api/User/EmployeeInfoText`.
         * @param {string} [employeeInfoText] 
         * @param {EmployeeInfoTextRequestV2} [employeeInfoTextRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeInfoTextPut(employeeInfoText?: string, employeeInfoTextRequestV2?: EmployeeInfoTextRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeInfoTextPut(employeeInfoText, employeeInfoTextRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reads the caller\'s time-card display preferences. Replaces TaAPI  `GET /api/User/EmployeeTimeCardSettings`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeTimeCardSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTimeCardSettingsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeTimeCardSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Persists the caller\'s time-card display preferences. Replaces TaAPI  `PUT /api/User/EmployeeTimeCardSettings`.
         * @param {EmployeeTimeCardSettingsRequestV2} [employeeTimeCardSettingsRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserEmployeeTimeCardSettingsPut(employeeTimeCardSettingsRequestV2?: EmployeeTimeCardSettingsRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserEmployeeTimeCardSettingsPut(employeeTimeCardSettingsRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns every raw `(PreferenceId, PreferenceValue)` row stored for the caller.  Replaces TaAPI `GET /api/User/Preferences`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserPreferencesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeePreferenceResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserPreferencesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the caller\'s last-viewed employees, most recent first (at most five).  The list is always the JWT caller\'s — there is no way to read another user\'s recents.  Missing, deleted, or no-longer-authorized employees are omitted. An empty list is  `200 []`, not 204,  so the sidebar can bind without a no-content branch. Each row includes  `isActive` and `pictureUrl` with the same semantics as  `POST /api/v2/employees`. After the FE opens an employee  (`GET /employees/{id}/header` records the view), it should call this GET again  so the sidebar reflects server order without duplicating list rules.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2UserRecentlyViewedEmployeesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecentlyViewedEmployeeResponseV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2UserRecentlyViewedEmployeesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserV2Api - factory interface
 * @export
 */
export const UserV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Reads the caller\'s employee-list filter settings (labor-level scope + status type  visibility map). Replaces TaAPI `GET /api/User/EmployeeFilteringSettings`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeFilteringSettingsGet(options?: AxiosRequestConfig): AxiosPromise<EmployeeFilteringSettingsV2> {
            return localVarFp.apiV2UserEmployeeFilteringSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Persists the caller\'s employee-list filter settings. Replaces TaAPI  `PUT /api/User/EmployeeFilteringSettings`.
         * @param {UserV2ApiApiV2UserEmployeeFilteringSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeFilteringSettingsPut(requestParameters: UserV2ApiApiV2UserEmployeeFilteringSettingsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2UserEmployeeFilteringSettingsPut(requestParameters.employeeFilteringSettingsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reads the caller\'s Employee-Center grouping preferences (labor-level depth +  display order per slot). Replaces TaAPI `GET /api/User/EmployeeGroupingLaborLevels`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeGroupingLaborLevelsGet(options?: AxiosRequestConfig): AxiosPromise<EmployeeGroupingLaborLevelsResponseV2> {
            return localVarFp.apiV2UserEmployeeGroupingLaborLevelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Persists the caller\'s Employee-Center grouping preferences. Replaces TaAPI  `PUT /api/User/EmployeeGroupingLaborLevels`.
         * @param {UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeGroupingLaborLevelsPut(requestParameters: UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2UserEmployeeGroupingLaborLevelsPut(requestParameters.employeeGroupingLaborLevelsRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reads the caller\'s preferred report ordering (employee id vs full name first).  Replaces TaAPI `GET /api/User/EmployeeIDFullNameDisplayOrder`. Returns the  numeric enum value so the wire shape matches TaAPI exactly (TaAPI emits `0`  while the global `JsonStringEnumConverter` would otherwise emit  `\"FullNameEmployeeID\"`). The PUT accepts both forms for forward compatibility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeIdFullNameDisplayOrderGet(options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2UserEmployeeIdFullNameDisplayOrderGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Persists the caller\'s preferred report ordering. Replaces TaAPI  `PUT /api/User/EmployeeIDFullNameDisplayOrder`. TaAPI accepts the body as  EITHER the numeric value (`0`) OR the string name (`\"FullNameEmployeeID\"`);  the FE sends the string form. Accepting both keeps wire parity with TaAPI without  reintroducing the global JsonStringEnumConverter (which would flip every enum-typed  response field to string).
         * @param {UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeIdFullNameDisplayOrderPut(requestParameters: UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2UserEmployeeIdFullNameDisplayOrderPut(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the tab-visibility flags evaluated against the target employee\'s role and  the active license. Manager roles may pass any employee id within their facility;  a non-manager caller (e.g. mobile Employee) is constrained by  OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute to their own JWT  `EmployeeInstanceId`. Replaces TaAPI `GET /api/User/{employeeId}/TabsVisibility`.
         * @param {UserV2ApiApiV2UserEmployeeIdTabsVisibilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeIdTabsVisibilityGet(requestParameters: UserV2ApiApiV2UserEmployeeIdTabsVisibilityGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeTabVisibilityPermissions> {
            return localVarFp.apiV2UserEmployeeIdTabsVisibilityGet(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reads the caller\'s free-text Employee-Info template. Returns an empty string  when the preference has not been set (LegacyApp fallback default lives in  `FacilityEmployeeServiceV2.GetEmployeeInfoTextAsync`, not here). Replaces  TaAPI `GET /api/User/EmployeeInfoText`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeInfoTextGet(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV2UserEmployeeInfoTextGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts the new value via EITHER a query parameter (`?employeeInfoText=...`,  the TaAPI wire shape) OR a JSON body (the more RESTful shape that V2 historically  used). The query parameter takes precedence when both are supplied so existing FE  callers built against TaAPI continue to work unchanged. An empty payload — empty  query value AND empty body — is treated as a \"clear\" operation.
         * @summary Persists the caller\'s free-text Employee-Info template. Replaces TaAPI  `PUT /api/User/EmployeeInfoText`.
         * @param {UserV2ApiApiV2UserEmployeeInfoTextPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeInfoTextPut(requestParameters: UserV2ApiApiV2UserEmployeeInfoTextPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2UserEmployeeInfoTextPut(requestParameters.employeeInfoText, requestParameters.employeeInfoTextRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reads the caller\'s time-card display preferences. Replaces TaAPI  `GET /api/User/EmployeeTimeCardSettings`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeTimeCardSettingsGet(options?: AxiosRequestConfig): AxiosPromise<EmployeeTimeCardSettingsV2> {
            return localVarFp.apiV2UserEmployeeTimeCardSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Persists the caller\'s time-card display preferences. Replaces TaAPI  `PUT /api/User/EmployeeTimeCardSettings`.
         * @param {UserV2ApiApiV2UserEmployeeTimeCardSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserEmployeeTimeCardSettingsPut(requestParameters: UserV2ApiApiV2UserEmployeeTimeCardSettingsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2UserEmployeeTimeCardSettingsPut(requestParameters.employeeTimeCardSettingsRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns every raw `(PreferenceId, PreferenceValue)` row stored for the caller.  Replaces TaAPI `GET /api/User/Preferences`.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserPreferencesGet(options?: AxiosRequestConfig): AxiosPromise<Array<EmployeePreferenceResponseV2>> {
            return localVarFp.apiV2UserPreferencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the caller\'s last-viewed employees, most recent first (at most five).  The list is always the JWT caller\'s — there is no way to read another user\'s recents.  Missing, deleted, or no-longer-authorized employees are omitted. An empty list is  `200 []`, not 204,  so the sidebar can bind without a no-content branch. Each row includes  `isActive` and `pictureUrl` with the same semantics as  `POST /api/v2/employees`. After the FE opens an employee  (`GET /employees/{id}/header` records the view), it should call this GET again  so the sidebar reflects server order without duplicating list rules.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2UserRecentlyViewedEmployeesGet(options?: AxiosRequestConfig): AxiosPromise<Array<RecentlyViewedEmployeeResponseV2>> {
            return localVarFp.apiV2UserRecentlyViewedEmployeesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2UserEmployeeFilteringSettingsPut operation in UserV2Api.
 * @export
 * @interface UserV2ApiApiV2UserEmployeeFilteringSettingsPutRequest
 */
export interface UserV2ApiApiV2UserEmployeeFilteringSettingsPutRequest {
    /**
     * 
     * @type {EmployeeFilteringSettingsV2}
     * @memberof UserV2ApiApiV2UserEmployeeFilteringSettingsPut
     */
    readonly employeeFilteringSettingsV2?: EmployeeFilteringSettingsV2
}

/**
 * Request parameters for apiV2UserEmployeeGroupingLaborLevelsPut operation in UserV2Api.
 * @export
 * @interface UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPutRequest
 */
export interface UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPutRequest {
    /**
     * 
     * @type {EmployeeGroupingLaborLevelsRequestV2}
     * @memberof UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPut
     */
    readonly employeeGroupingLaborLevelsRequestV2?: EmployeeGroupingLaborLevelsRequestV2
}

/**
 * Request parameters for apiV2UserEmployeeIdFullNameDisplayOrderPut operation in UserV2Api.
 * @export
 * @interface UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPutRequest
 */
export interface UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPutRequest {
    /**
     * 
     * @type {any}
     * @memberof UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPut
     */
    readonly body?: any
}

/**
 * Request parameters for apiV2UserEmployeeIdTabsVisibilityGet operation in UserV2Api.
 * @export
 * @interface UserV2ApiApiV2UserEmployeeIdTabsVisibilityGetRequest
 */
export interface UserV2ApiApiV2UserEmployeeIdTabsVisibilityGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserV2ApiApiV2UserEmployeeIdTabsVisibilityGet
     */
    readonly employeeId: number
}

/**
 * Request parameters for apiV2UserEmployeeInfoTextPut operation in UserV2Api.
 * @export
 * @interface UserV2ApiApiV2UserEmployeeInfoTextPutRequest
 */
export interface UserV2ApiApiV2UserEmployeeInfoTextPutRequest {
    /**
     * 
     * @type {string}
     * @memberof UserV2ApiApiV2UserEmployeeInfoTextPut
     */
    readonly employeeInfoText?: string

    /**
     * 
     * @type {EmployeeInfoTextRequestV2}
     * @memberof UserV2ApiApiV2UserEmployeeInfoTextPut
     */
    readonly employeeInfoTextRequestV2?: EmployeeInfoTextRequestV2
}

/**
 * Request parameters for apiV2UserEmployeeTimeCardSettingsPut operation in UserV2Api.
 * @export
 * @interface UserV2ApiApiV2UserEmployeeTimeCardSettingsPutRequest
 */
export interface UserV2ApiApiV2UserEmployeeTimeCardSettingsPutRequest {
    /**
     * 
     * @type {EmployeeTimeCardSettingsRequestV2}
     * @memberof UserV2ApiApiV2UserEmployeeTimeCardSettingsPut
     */
    readonly employeeTimeCardSettingsRequestV2?: EmployeeTimeCardSettingsRequestV2
}

/**
 * UserV2Api - object-oriented interface
 * @export
 * @class UserV2Api
 * @extends {BaseAPI}
 */
export class UserV2Api extends BaseAPI {
    /**
     * 
     * @summary Reads the caller\'s employee-list filter settings (labor-level scope + status type  visibility map). Replaces TaAPI `GET /api/User/EmployeeFilteringSettings`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeFilteringSettingsGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeFilteringSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Persists the caller\'s employee-list filter settings. Replaces TaAPI  `PUT /api/User/EmployeeFilteringSettings`.
     * @param {UserV2ApiApiV2UserEmployeeFilteringSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeFilteringSettingsPut(requestParameters: UserV2ApiApiV2UserEmployeeFilteringSettingsPutRequest = {}, options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeFilteringSettingsPut(requestParameters.employeeFilteringSettingsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reads the caller\'s Employee-Center grouping preferences (labor-level depth +  display order per slot). Replaces TaAPI `GET /api/User/EmployeeGroupingLaborLevels`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeGroupingLaborLevelsGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeGroupingLaborLevelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Persists the caller\'s Employee-Center grouping preferences. Replaces TaAPI  `PUT /api/User/EmployeeGroupingLaborLevels`.
     * @param {UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeGroupingLaborLevelsPut(requestParameters: UserV2ApiApiV2UserEmployeeGroupingLaborLevelsPutRequest = {}, options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeGroupingLaborLevelsPut(requestParameters.employeeGroupingLaborLevelsRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reads the caller\'s preferred report ordering (employee id vs full name first).  Replaces TaAPI `GET /api/User/EmployeeIDFullNameDisplayOrder`. Returns the  numeric enum value so the wire shape matches TaAPI exactly (TaAPI emits `0`  while the global `JsonStringEnumConverter` would otherwise emit  `\"FullNameEmployeeID\"`). The PUT accepts both forms for forward compatibility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeIdFullNameDisplayOrderGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeIdFullNameDisplayOrderGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Persists the caller\'s preferred report ordering. Replaces TaAPI  `PUT /api/User/EmployeeIDFullNameDisplayOrder`. TaAPI accepts the body as  EITHER the numeric value (`0`) OR the string name (`\"FullNameEmployeeID\"`);  the FE sends the string form. Accepting both keeps wire parity with TaAPI without  reintroducing the global JsonStringEnumConverter (which would flip every enum-typed  response field to string).
     * @param {UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeIdFullNameDisplayOrderPut(requestParameters: UserV2ApiApiV2UserEmployeeIdFullNameDisplayOrderPutRequest = {}, options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeIdFullNameDisplayOrderPut(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the tab-visibility flags evaluated against the target employee\'s role and  the active license. Manager roles may pass any employee id within their facility;  a non-manager caller (e.g. mobile Employee) is constrained by  OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute to their own JWT  `EmployeeInstanceId`. Replaces TaAPI `GET /api/User/{employeeId}/TabsVisibility`.
     * @param {UserV2ApiApiV2UserEmployeeIdTabsVisibilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeIdTabsVisibilityGet(requestParameters: UserV2ApiApiV2UserEmployeeIdTabsVisibilityGetRequest, options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeIdTabsVisibilityGet(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reads the caller\'s free-text Employee-Info template. Returns an empty string  when the preference has not been set (LegacyApp fallback default lives in  `FacilityEmployeeServiceV2.GetEmployeeInfoTextAsync`, not here). Replaces  TaAPI `GET /api/User/EmployeeInfoText`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeInfoTextGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeInfoTextGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts the new value via EITHER a query parameter (`?employeeInfoText=...`,  the TaAPI wire shape) OR a JSON body (the more RESTful shape that V2 historically  used). The query parameter takes precedence when both are supplied so existing FE  callers built against TaAPI continue to work unchanged. An empty payload — empty  query value AND empty body — is treated as a \"clear\" operation.
     * @summary Persists the caller\'s free-text Employee-Info template. Replaces TaAPI  `PUT /api/User/EmployeeInfoText`.
     * @param {UserV2ApiApiV2UserEmployeeInfoTextPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeInfoTextPut(requestParameters: UserV2ApiApiV2UserEmployeeInfoTextPutRequest = {}, options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeInfoTextPut(requestParameters.employeeInfoText, requestParameters.employeeInfoTextRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reads the caller\'s time-card display preferences. Replaces TaAPI  `GET /api/User/EmployeeTimeCardSettings`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeTimeCardSettingsGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeTimeCardSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Persists the caller\'s time-card display preferences. Replaces TaAPI  `PUT /api/User/EmployeeTimeCardSettings`.
     * @param {UserV2ApiApiV2UserEmployeeTimeCardSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserEmployeeTimeCardSettingsPut(requestParameters: UserV2ApiApiV2UserEmployeeTimeCardSettingsPutRequest = {}, options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserEmployeeTimeCardSettingsPut(requestParameters.employeeTimeCardSettingsRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns every raw `(PreferenceId, PreferenceValue)` row stored for the caller.  Replaces TaAPI `GET /api/User/Preferences`.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserPreferencesGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserPreferencesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the caller\'s last-viewed employees, most recent first (at most five).  The list is always the JWT caller\'s — there is no way to read another user\'s recents.  Missing, deleted, or no-longer-authorized employees are omitted. An empty list is  `200 []`, not 204,  so the sidebar can bind without a no-content branch. Each row includes  `isActive` and `pictureUrl` with the same semantics as  `POST /api/v2/employees`. After the FE opens an employee  (`GET /employees/{id}/header` records the view), it should call this GET again  so the sidebar reflects server order without duplicating list rules.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserV2Api
     */
    public apiV2UserRecentlyViewedEmployeesGet(options?: AxiosRequestConfig) {
        return UserV2ApiFp(this.configuration).apiV2UserRecentlyViewedEmployeesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
